/**
 * 模块英文映射占位文件
 *
 * 逐页改造时，各业务模块的「中文原文 → 英文」映射放到本目录下的独立文件
 * （如 meterManagement.js），由 index.js 通过 require.context 自动合并。
 * 本文件仅保证目录存在，可随时删除。
 */
export default {}
